import axios from 'axios';
import { API_URL } from '../Auth/constansts';

const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${API_URL}/forgotpassword?email=${email}`, {
      method: 'get',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
    });
    if (response.ok) {
      console.log("envio");
      const json = await response.json();
      return json;
    }
    return 403;
  } catch (error) {
    return 500;
  }
}

const resetPassword = async (email, token, password, compassword) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/resetpassword`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        email: email,
        token:token,
        password:password,
        password_confirmation:compassword
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const loginAPI = async (email,password) => {
  try {
    const response = await fetch(`${API_URL}/login`, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email,
        password
      }),
    });
    if (response.ok) {
      const json = await response.json();
      return json;
    }
    return 403;

  } catch (error) {
    return 500;
  }
}

const logoutAPI = async (token) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/logout`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return 200;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const getusercompanies = async (token) => {
  try {

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/user`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      var companies = [];
      for (var i = 0; i < data.data.empresas.length; i++) {
        var datacom = [
          data.data.empresas[i].id,
          data.data.empresas[i].name,
        ]
        companies[i] = datacom;
      }
      return companies;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const getusermenu = async (token, company) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/menu`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        company: company
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const can = async (token, company, page) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/can`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      data: {
        company: company,
         page: page
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data.data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const getuserdata = async (token) => {
  try {

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/user`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      var dataInput = [];
      dataInput.id = data.data.id;
      dataInput.name = data.data.name;
      return dataInput;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const getcompany = async (token) => {
  try {
    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${API_URL}/getEmpresa`,
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    };
    const data = await axios.request(config);
    if (data.status === 200) {
      return data;
    }
    else {
      return 201;
    }
  } catch (error) {
    return 500;
  }
}

const CreateUser = async (email,role, token, companyid) => {
  try {
    const response = await fetch(`${API_URL}/createuser`, {
      method: 'post',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify({
        email:email,
        role:role,
        companyid:companyid
      }),
    });
    if (response.ok) {
      const json = await response.json();
      return json;
    }
    return 403;

  } catch (error) {
    return 500;
  }
}

export {
  logoutAPI,
  getcompany,
  getuserdata,
  getusercompanies,
  getusermenu,
  can,
  loginAPI,
  CreateUser,
  forgotPassword,
  resetPassword
}